import React from 'react';
import { AuthContext } from './AuthContext';

export const DemoAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: true,
        isLoadingCached: false,
        user: {
          email: 'demo@tachusa.com',
          sub: 'demo-sub-id',
          email_verified: true,
        },
        loginWithRedirect: async () => {
          window.location.href = '/login';
        },
        getAccessToken: async () => 'demo-token',
        logout: async () => {
          window.location.href = '/login';
        },
        handleRedirectCallback: async () => {},
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
